"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryLevelSchema = exports.BoundaryLevel = void 0;
exports.getHighestBoundaryLevel = getHighestBoundaryLevel;
exports.getHighestBoundaryLevelFromArray = getHighestBoundaryLevelFromArray;
const zod_1 = require("zod");
var BoundaryLevel;
(function (BoundaryLevel) {
    BoundaryLevel["Recommendation"] = "recommend";
    BoundaryLevel["Warning"] = "warning";
    BoundaryLevel["Error"] = "error";
})(BoundaryLevel || (exports.BoundaryLevel = BoundaryLevel = {}));
exports.BoundaryLevelSchema = zod_1.z.nativeEnum(BoundaryLevel);
function getHighestBoundaryLevel(a, b) {
    return (a === BoundaryLevel.Error || b === BoundaryLevel.Error ? BoundaryLevel.Error
        : a === BoundaryLevel.Warning || b === BoundaryLevel.Warning ? BoundaryLevel.Warning
            : BoundaryLevel.Recommendation);
}
function getHighestBoundaryLevelFromArray(levels, defaultLevel = BoundaryLevel.Recommendation) {
    return (levels.reduce((acc, level) => (level !== undefined ? getHighestBoundaryLevel(acc, level) : acc), defaultLevel) ?? defaultLevel);
}
//# sourceMappingURL=BoundaryLevel.js.map